export const DEFAULT_BRAND_KEY = "intel";

const CLOUDINARY_BASE = "https://res.cloudinary.com/drzta9shk/image/upload";

const INTEL_LOGO = `${CLOUDINARY_BASE}/v1645085709/global/trademo_logo/justLogo_mr5y0j.svg`;
const INTEL_FAVICON = `${CLOUDINARY_BASE}/q_auto:eco/v1645085709/global/trademo_logo/justLogo_mr5y0j.svg`;

export const BRANDS = {
  intel: {
    key: "intel",
    name: "Trademo Intel",
    shortName: "Intel",
    titleSuffix: "Trademo Intel",
    logo: INTEL_LOGO,
    favicon: INTEL_FAVICON,
    aiAssistantName: "Hermes AI",
  },
  source_atlas: {
    key: "source_atlas",
    name: "Source Atlas",
    shortName: "Source Atlas",
    titleSuffix: "Trademo Source Atlas",
    logo: INTEL_LOGO,
    favicon: INTEL_FAVICON,
    aiAssistantName: "Source Atlas AI",
  },
};

export function resolveBrand(brandKey) {
  if (!brandKey) return BRANDS[DEFAULT_BRAND_KEY];
  const brand = BRANDS[brandKey];
  if (!brand) {
    throw new Error(`Unknown VITE_BRAND "${brandKey}". Expected one of: ${Object.keys(BRANDS).join(", ")}.`);
  }
  return brand;
}
